import App from 'app/app.js';

var drawer = function LtSelectionDrawerCtrl($scope, $timeout) {
  this.init = function () {
    $scope.onInit({ drawer: this });
  };

  this.open = function () {
    this.visible = true;
    $timeout(function () {
      //these new full-screen-replace ones still have this attribute, but not the other one that controls the UI-Blocker
      $('body').css('overflow', 'hidden');
      if ($('div[lt-drawer-cancellation]:visible').length) {
        if (!$('div[lt-drawer-cancellation]:visible')[0].classList.contains('custom-popup')) {
          $('div[lt-drawer-cancellation]:visible')[0].scrollIntoView({ behavior: 'smooth' });
        }
      }
      if ($scope.onOpen) {
        $scope.onOpen();
      }
    }, 1);
  };

  this.close = function () {
    this.visible = false;
    $('body').css('overflow', 'auto');
    if (document.getElementById('popUpModal') != null) {
      var element = document.getElementById('popUpModal');
      element.setAttribute('style', 'display: none;');
    }
  };

  this.cancel = function () {
    this.close();
    $scope.onCancellation();
    $('body').css('overflow', 'auto');
  };
};

export default drawer;
